
import { defineComponent, computed } from 'vue';
import { openHelp } from '@/helpers/Gleap';
import Message from 'primevue/message';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';

export default defineComponent({
  name: 'HelpMessage',

  components: {
    SpmButton,
    Message,
  },

  props: {
    message: {
      type: String,
      required: false,
      default: undefined,
    },

    link: {
      type: Object as () => {
        type: 'gleap' | 'external';
        articleId?: string;
        url?: string;
        label: string;
      },

      required: true,
    },

    customClass: {
      type: String,
      required: false,
      default: '',
    },
  },

  setup(props) {
    const showExternalIcon = computed(() => props.link.type === 'external');
    function handleClick() {
      if (props.link.type === 'gleap' && props.link.articleId) {
        openHelp(props.link.articleId, false);
      } else if (props.link.type === 'external' && props.link.url) {
        window.open(props.link.url, '_blank');
      }
    }

    return {
      handleClick,
      showExternalIcon,
      ...props,
    };
  },
});
